

































# import settings from '@/settings'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'company_informations'
    components: {
        Menus
    }

    watch:
        '$route': (route_to, route_from)->
            # console.log "WATCH ROUTE", route_to,
            if route_to.name == 'company_informations'
                @define_route()

    data: ()->
        informations_accesses: ['company_show', 'establishments_show', 'jobs_show', 'skills_show', 'recruitments_show']
        change_distribution_data: false

    methods:
        has_access_right: t.has_access_right

        change_distribution: ()->
            @change_distribution_data = !@change_distribution_data
            # console.log "EMIT COMPANY INFORMATION END", @change_distribution_data

        define_route: ()->
            if @$store.state.selected_company['uid'] != ''
                for a in @informations_accesses
                    if @has_access_right(a)
                        a_name = a.split('_')
                        name = "company_"+a_name[0]
                        if name == "company_company"
                            @$router.push({name:name, params:{uid:@$store.state.selected_company['uid']}})
                            .catch((err)-> {})
                        else
                            @$router.push({name:name})
                            .catch((err)-> {})
                        break

    mounted: ()->
        # console.log "INFORMATION MOUTNED", @$store.state.selected_company['name']
        @define_route()   
}

